/* NS PROMO quote request builder v4 (2026-10-17).
   Colours x sizes x quantities -> decoration -> details. On submit: contact-form email (native) + Shopify draft order (app proxy, non-blocking).
   30 Oct 2026 - below-MOQ wording aligned with policy (reviewed, surcharge may apply); summary flags below-MOQ;
   removing a filled colour uses an in-page "tap again" prompt instead of window.confirm;
   colour swatches show their name (long single words shrink to fit);
   palettes taller than 3 rows start at 2.5 rows with a "Show all" toggle. */
(function () {
  'use strict';
  var ENDPOINT = '/apps/artwork-upload/quote';
  var SOURCE = 'product-page-quote';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try { return '$' + v.toLocaleString('en-AU', {minimumFractionDigits: 2, maximumFractionDigits: 2}); } catch (e) { return '$' + v.toFixed(2); }
  }
  function clean(v) { v = String(v == null ? '' : v).trim(); return /^default title$/i.test(v) ? '' : v; }

  function Builder(root) {
    var node = $(root, 'script[data-q-data]');
    if (!node) return;
    try { this.d = JSON.parse(node.textContent); } catch (e) { console.error('NS quote data', e); return; }
    this.d.moq = Math.round(Number(this.d.moq)) || 10;
    this.root = root;
    this.form = $(root, 'form.nsq4__form');
    this.rows = [];
    this.methods = [];
    this.positions = [];
    this.engaged = false;
    this.pendingRemove = null;
    this.paletteOpen = false;
    this.index();
    this.render();
    this.bind();
    var cur = this.groupOfVariant(this.d.current);
    if (cur) this.addRow(cur, true);
    this.update();
    var self = this;
    if (window.requestAnimationFrame) window.requestAnimationFrame(function () { self.fitPalette(); }); else this.fitPalette();
    window.addEventListener('load', function () { self.fitPalette(); });
    try { document.dispatchEvent(new CustomEvent('nsp:product-ui-ready')); } catch (e) {}
  }

  Builder.prototype.index = function () {
    var d = this.d, si = d.sizeIndex, groups = {}, order = [];
    this.sizeOrder = (d.sizes && d.sizes.length) ? d.sizes.slice() : ['One size'];
    (d.variants || []).forEach(function (v) {
      var parts = [], labels = [];
      (v.o || []).forEach(function (val, i) {
        if (i === si) return;
        val = clean(val);
        if (val) { parts.push(i + '=' + val); labels.push(val); }
      });
      var key = parts.join('|') || 'default';
      if (!groups[key]) { groups[key] = {key: key, label: labels.join(' / ') || 'Standard', opts: v.o || [], bySize: {}}; order.push(key); }
      var size = si >= 0 ? clean(v.o[si]) : 'One size';
      groups[key].bySize[size || 'One size'] = v;
    });
    this.groups = groups;
    this.order = order;
    this.colourOnly = d.colourIndex >= 0 && (d.options || []).length - (si >= 0 ? 1 : 0) === 1;
  };

  Builder.prototype.groupOfVariant = function (id) {
    for (var i = 0; i < this.order.length; i++) {
      var g = this.groups[this.order[i]], s;
      for (s in g.bySize) if (String(g.bySize[s].id) === String(id)) return g.key;
    }
    return this.order[0];
  };

  Builder.prototype.swatch = function (g) {
    var colour = this.d.colourIndex >= 0 ? clean(g.opts[this.d.colourIndex]) : '';
    var style = colour && this.d.swatches ? (this.d.swatches[colour] || '') : '';
    return '<span class="nsq4__sw" style="' + esc(style) + '"></span>';
  };

  Builder.prototype.moreLabel = function () {
    return this.paletteOpen ? 'Show fewer' : 'Show all ' + this.order.length + (this.colourOnly ? ' colours' : ' options');
  };

  Builder.prototype.render = function () {
    var self = this, pal = $(this.root, '[data-q-palette]'), wrap = $(this.root, '[data-q-palette-wrap]');
    if (this.order.length <= 1) { if (wrap) wrap.hidden = true; }
    else if (pal) {
      var hint = $(this.root, '[data-q-palette-hint]');
      if (hint && !this.colourOnly) hint.textContent = 'Choose an option to add it. You can add several.';
      pal.innerHTML = this.order.map(function (k) {
        var g = self.groups[k];
        return '<button type="button" class="nsq4__pal' + (self.colourOnly ? '' : ' nsq4__pal--text') + '" data-q-add="' + esc(k) + '" aria-pressed="false" title="' + esc(g.label) + '">' +
          (self.colourOnly ? self.swatch(g) + '<span class="nsq4__pal-name">' + esc(g.label) + '</span>' : esc(g.label)) + '</button>';
      }).join('');
      if (this.order.length > 6 && !$(this.root, '[data-q-more]')) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'nsq4__more';
        more.setAttribute('data-q-more', '');
        more.setAttribute('aria-expanded', 'false');
        more.hidden = true;
        more.textContent = this.moreLabel();
        pal.parentNode.insertBefore(more, pal.nextSibling);
      }
    }
  };

  /* Shrink a colour name that is a single word too long for its tile (e.g. "Eucalyptus" on phones). */
  function fitNames(p) {
    $$(p, '.nsq4__pal-name').forEach(function (n) {
      n.style.fontSize = '';
      if (n.clientWidth && n.scrollWidth > n.clientWidth + 1) {
        var fs = parseFloat(window.getComputedStyle(n).fontSize) || 10;
        n.style.fontSize = Math.max(8, Math.floor(fs * n.clientWidth / n.scrollWidth * 10) / 10) + 'px';
      }
    });
  }

  /* Collapse a palette taller than 3 rows to 2.5 rows; the half row shows there is more. */
  Builder.prototype.fitPalette = function () {
    var p = $(this.root, '[data-q-palette]'), more = $(this.root, '[data-q-more]');
    if (!p) return;
    fitNames(p);
    if (!more) return;
    p.classList.remove('is-collapsed');
    p.style.maxHeight = '';
    var kids = p.children, tops = [], i, t;
    for (i = 0; i < kids.length; i++) { t = kids[i].offsetTop; if (tops.indexOf(t) === -1) tops.push(t); }
    if (tops.length <= 3) { more.hidden = true; return; }
    more.hidden = false;
    more.textContent = this.moreLabel();
    more.setAttribute('aria-expanded', this.paletteOpen ? 'true' : 'false');
    if (this.paletteOpen) return;
    var sw = $(kids[0], '.nsq4__sw'), h = sw ? sw.offsetHeight : kids[0].offsetHeight;
    p.style.maxHeight = Math.round(tops[2] - tops[0] + h * 0.55) + 'px';
    p.classList.add('is-collapsed');
  };

  Builder.prototype.rowIndex = function (key) {
    for (var i = 0; i < this.rows.length; i++) if (this.rows[i].key === key) return i;
    return -1;
  };

  Builder.prototype.addRow = function (key, silent) {
    if (!this.groups[key]) return;
    var i = this.rowIndex(key);
    if (i === -1) { this.rows.push({key: key, q: {}}); this.renderRows(); }
    var input = $(this.root, '[data-q-row="' + cssEsc(key) + '"] input:not([disabled])');
    if (!silent && input && window.matchMedia('(hover: hover)').matches) { try { input.focus({preventScroll: false}); } catch (e) { input.focus(); } }
    if (!silent) this.syncNative(key);
  };

  Builder.prototype.removeRow = function (key) {
    var i = this.rowIndex(key);
    if (i > -1) this.rows.splice(i, 1);
    if (this.pendingRemove === key) this.pendingRemove = null;
    this.renderRows();
    this.update();
  };

  Builder.prototype.askRemove = function (key) {
    var self = this, m = $(this.root, '[data-q-items-msg]');
    this.pendingRemove = key;
    if (m) { m.textContent = 'Tap ' + this.groups[key].label + ' again to remove it and its quantities.'; m.hidden = false; }
    clearTimeout(this.removeTimer);
    this.removeTimer = setTimeout(function () {
      if (self.pendingRemove === key) { self.pendingRemove = null; if (m) m.hidden = true; }
    }, 4000);
  };

  Builder.prototype.renderRows = function () {
    var self = this, box = $(this.root, '[data-q-rows]');
    if (!box) return;
    box.innerHTML = this.rows.map(function (row) {
      var g = self.groups[row.key];
      var cells = self.sizeOrder.map(function (size) {
        var v = g.bySize[size], ok = v && v.a, val = row.q[size] || '';
        return '<label class="nsq4__cell' + (ok ? '' : ' is-off') + (val ? ' is-filled' : '') + '"><span>' + esc(size) + '</span>' +
          '<input type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" placeholder="0" value="' + esc(val) + '" data-q-size="' + esc(size) + '"' +
          (ok ? '' : ' disabled title="Not available"') + ' aria-label="' + esc(g.label + ' ' + size) + ' quantity"></label>';
      }).join('');
      return '<div class="nsq4__row" data-q-row="' + esc(row.key) + '">' +
        '<div class="nsq4__row-head">' + (self.colourOnly ? self.swatch(g) : '') + '<strong>' + esc(g.label) + '</strong>' +
        '<span class="nsq4__row-qty" data-q-row-qty>0 pcs</span>' +
        (self.order.length > 1 ? '<button type="button" class="nsq4__x" data-q-remove="' + esc(row.key) + '" aria-label="Remove ' + esc(g.label) + '">×</button>' : '') +
        '</div><div class="nsq4__cells">' + cells + '</div></div>';
    }).join('');
    $$(this.root, '[data-q-add]').forEach(function (b) {
      var on = self.rowIndex(b.getAttribute('data-q-add')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  Builder.prototype.totals = function () {
    var self = this, qty = 0, lines = [], text = [];
    this.rows.forEach(function (row) {
      var g = self.groups[row.key], parts = [];
      self.sizeOrder.forEach(function (size) {
        var n = row.q[size] || 0, v = g.bySize[size];
        if (n > 0 && v) { qty += n; lines.push({v: v, n: n}); parts.push(size + ' ×' + n); }
      });
      if (parts.length) text.push(g.label + ': ' + parts.join(', '));
    });
    var band = null;
    (this.d.bands || []).forEach(function (b) { if (qty >= b.min) band = b; });
    var off = band ? band.off : 0, total = 0;
    lines.forEach(function (l) { total += Math.round(l.v.p * (100 - off) / 100) * l.n; });
    return {qty: qty, lines: lines, band: band, off: off, total: total, text: text.join(' | ')};
  };

  Builder.prototype.priceRange = function (off) {
    var self = this, keys = this.rows.length ? this.rows.map(function (r) { return r.key; }) : this.order, prices = [];
    keys.forEach(function (k) {
      var g = self.groups[k], s;
      for (s in g.bySize) if (g.bySize[s].a) prices.push(Math.round(g.bySize[s].p * (100 - off) / 100));
    });
    if (!prices.length) return '—';
    var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
    return min === max ? money(min) : money(min) + '<small>–' + money(max) + '</small>';
  };

  Builder.prototype.update = function () {
    var self = this, t = this.totals(), bands = this.d.bands || [], root = this.root, moq = this.d.moq;
    var below = t.qty > 0 && t.qty < moq;
    var tiers = $(root, '[data-q-tiers]');
    if (tiers) tiers.innerHTML = bands.map(function (b) {
      var active = t.band && t.band.min === b.min;
      return '<div class="nsq4__tier' + (active ? ' is-active' : '') + '"><span>' + b.min + '+ pcs</span><strong>' + self.priceRange(b.off) + '</strong><em>' + (b.off ? b.off + '% off' : 'Base price') + '</em></div>';
    }).join('');
    var nudge = $(root, '[data-q-nudge]'), next = null;
    bands.forEach(function (b) { if (!next && b.min > t.qty) next = b; });
    if (nudge) {
      if (!t.qty) nudge.textContent = 'Garment price per piece, ex GST. Decoration is quoted by our team.';
      else if (below) nudge.textContent = t.qty + ' pcs — below our minimum of ' + moq + ' per style. We\'ll review it — a surcharge may apply.';
      else if (next) nudge.textContent = 'Add ' + (next.min - t.qty) + ' more to reach ' + next.min + '+ (' + next.off + '% off garments).';
      else nudge.textContent = 'Best volume price unlocked.';
      nudge.classList.toggle('is-warn', below);
    }
    $$(root, '[data-q-row]').forEach(function (el) {
      var row = self.rows[self.rowIndex(el.getAttribute('data-q-row'))], n = 0, s;
      if (row) for (s in row.q) n += row.q[s];
      var lab = $(el, '[data-q-row-qty]');
      if (lab) lab.textContent = n + ' pcs';
    });
    var bandText = t.band ? t.band.min + '+ · ' + (t.off ? t.off + '% off' : 'base price') : (t.qty ? 'Below ' + moq + ' pcs · team review' : '—');
    var totalText = money(t.total);
    setText(root, '[data-q-sum-qty]', String(t.qty));
    setText(root, '[data-q-sum-band]', bandText);
    setText(root, '[data-q-sum-total]', totalText);
    setText(root, '[data-q-sticky-qty]', String(t.qty));
    setText(root, '[data-q-sticky-total]', totalText);
    var summary = $(root, '[data-q-summary]'), sumNote = summary ? $(summary, '.nsq4__summary-note') : null;
    if (summary) summary.classList.toggle('is-below', below);
    if (sumNote) {
      if (sumNote.__base == null) sumNote.__base = sumNote.textContent;
      sumNote.textContent = below ? 'Under ' + moq + ' per style: our team will review it and confirm any surcharge. ' + sumNote.__base : sumNote.__base;
    }
    setVal(root, 'selection', t.text);
    setVal(root, 'qty', String(t.qty));
    setVal(root, 'band', bandText);
    setVal(root, 'total', totalText + ' (garments only, ex GST)');
    setVal(root, 'methods', this.methods.join(', ') || 'Not selected');
    setVal(root, 'positions', this.positions.join(', ') || 'Not selected');
    if (t.qty && !this.pendingRemove) { var m = $(root, '[data-q-items-msg]'); if (m) m.hidden = true; }
    this.t = t;
    this.sticky();
  };

  Builder.prototype.sticky = function () {
    var bar = $(this.root, '[data-q-sticky]');
    if (!bar) return;
    var show = this.t && this.t.qty > 0 && !this.detailsVisible && window.matchMedia('(max-width: 989px)').matches;
    bar.hidden = !show;
  };

  Builder.prototype.toggleChip = function (btn, list, exclusiveAttr) {
    var val = btn.getAttribute(list === this.methods ? 'data-q-method' : 'data-q-position');
    var i = list.indexOf(val), group = btn.parentNode;
    if (exclusiveAttr && btn.hasAttribute('data-q-exclusive')) {
      list.length = 0;
      if (i === -1) list.push(val);
    } else {
      $$(group, '[data-q-exclusive]').forEach(function (x) { var j = list.indexOf(x.getAttribute('data-q-method')); if (j > -1) list.splice(j, 1); });
      i = list.indexOf(val);
      if (i > -1) list.splice(i, 1); else list.push(val);
    }
    $$(group, 'button').forEach(function (b) {
      var v = b.getAttribute('data-q-method') || b.getAttribute('data-q-position'), on = list.indexOf(v) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.update();
  };

  Builder.prototype.syncNative = function (key) {
    var g = this.groups[key], ci = this.d.colourIndex;
    if (!g || ci < 0) return;
    var section = this.root.closest('.shopify-section') || document;
    var picker = section.querySelector('hdt-variant-picker');
    if (!picker) return;
    var fs = picker.querySelector('fieldset[data-index="' + ci + '"]');
    if (!fs) return;
    var want = clean(g.opts[ci]);
    var target = $$(fs, 'input[is-value],button[role="option"],[role="option"][value]').filter(function (n) { return clean(n.value || n.getAttribute('value')) === want; })[0];
    if (target) { if (target.tagName === 'INPUT') { if (!target.checked) target.click(); } else target.click(); }
  };

  Builder.prototype.engage = function () {
    if (this.engaged) return;
    this.engaged = true;
    try { document.dispatchEvent(new CustomEvent('ns:quote-engaged', {detail: {productId: this.root.getAttribute('data-product-id') || ''}})); } catch (e) {}
  };

  Builder.prototype.goDetails = function () {
    var el = $(this.root, '[data-q-step="details"]');
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    try { window.scrollTo({top: top, behavior: 'smooth'}); } catch (e) { window.scrollTo(0, top); }
    var first = $(el, 'input[name="contact[Name]"]');
    if (first) setTimeout(function () { try { first.focus({preventScroll: true}); } catch (e) {} }, 500);
  };

  Builder.prototype.bind = function () {
    var self = this, root = this.root, rt = null;
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var b;
      if ((b = t.closest('[data-q-add]'))) {
        e.preventDefault(); self.engage();
        var key = b.getAttribute('data-q-add'), i = self.rowIndex(key);
        if (i > -1) {
          var row = self.rows[i], has = Object.keys(row.q).length;
          if (!has || self.pendingRemove === key) { self.removeRow(key); }
          else { self.update(); self.askRemove(key); }
        } else { self.addRow(key); self.update(); }
      } else if ((b = t.closest('[data-q-more]'))) {
        e.preventDefault();
        self.paletteOpen = !self.paletteOpen;
        self.fitPalette();
      } else if ((b = t.closest('[data-q-remove]'))) {
        e.preventDefault(); self.removeRow(b.getAttribute('data-q-remove'));
      } else if ((b = t.closest('[data-q-method]'))) {
        e.preventDefault(); self.engage(); self.toggleChip(b, self.methods, true);
      } else if ((b = t.closest('[data-q-position]'))) {
        e.preventDefault(); self.engage(); self.toggleChip(b, self.positions, false);
      } else if (t.closest('[data-q-goto-details]')) {
        e.preventDefault(); self.goDetails();
      } else if (t.closest('[data-q-sizeguide]')) {
        e.preventDefault();
        var tab = $(root, '[data-nspt-tab="size"]');
        if (tab) { if (!tab.classList.contains('is-active')) tab.click(); try { tab.scrollIntoView({behavior: 'smooth', block: 'center'}); } catch (x) {} }
      }
    });
    root.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('[data-q-size]')) return;
      self.engage();
      var raw = String(inp.value || '').replace(/[^\d]/g, '').slice(0, 5);
      inp.value = raw;
      var rowEl = inp.closest('[data-q-row]'), row = self.rows[self.rowIndex(rowEl.getAttribute('data-q-row'))], size = inp.getAttribute('data-q-size'), n = parseInt(raw, 10) || 0;
      if (!row) return;
      if (n > 0) row.q[size] = n; else delete row.q[size];
      inp.parentNode.classList.toggle('is-filled', n > 0);
      self.update();
    });
    root.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('[data-q-size]')) e.target.select(); });

    if ('IntersectionObserver' in window) {
      var det = $(root, '[data-q-step="details"]');
      if (det) new IntersectionObserver(function (en) { self.detailsVisible = en[0].isIntersecting; self.sticky(); }, {rootMargin: '0px 0px -30% 0px'}).observe(det);
    }
    window.addEventListener('resize', function () {
      self.sticky();
      clearTimeout(rt);
      rt = setTimeout(function () { self.fitPalette(); }, 150);
    });

    if (this.form) {
      window.addEventListener('submit', function (e) {
        if (e.target !== self.form) return;
        self.update();
        if (!self.t.qty) return;
        var btn = $(self.form, '[type="submit"]');
        if (btn && btn.disabled) return;
        self.sendDraft();
      }, true);
      this.form.addEventListener('submit', function (e) {
        self.update();
        if (!self.t.qty) {
          e.preventDefault();
          var m = $(root, '[data-q-items-msg]');
          if (m) { m.textContent = 'Please enter at least one quantity.'; m.hidden = false; }
          var step = $(root, '[data-q-step="items"]');
          if (step) try { step.scrollIntoView({behavior: 'smooth', block: 'center'}); } catch (x) {}
        }
      });
    }
  };

  Builder.prototype.sendDraft = function () {
    var form = this.form, t = this.t, fields = {}, skip = ['Product', 'Product URL', 'Selection', 'Total Quantity', 'Price Band', 'Estimated Product Total EX GST', 'Decoration Preference', 'Quote ref'];
    Array.prototype.forEach.call(form.elements, function (el) {
      var m = /^contact\[(.+)\]$/.exec(el.name || '');
      if (!m || el.type === 'file' || el.disabled || skip.indexOf(m[1]) > -1) return;
      var v = String(el.value || '').trim();
      if (v) fields[m[1]] = v;
    });
    var lines = t.lines.map(function (l) { return {variantId: String(l.v.id), quantity: l.n}; });
    var sig = JSON.stringify([lines, fields]);
    if (form.__qSig === sig) return;
    form.__qSig = sig;
    var ref = makeRef();
    fields['Quote ref'] = ref;
    var h = $(form, 'input[name="contact[Quote ref]"]');
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[Quote ref]'; form.appendChild(h); }
    h.value = ref;
    var hp = $(form, '[name="website"]');
    var body = {
      source: SOURCE, ref: ref, website: hp ? hp.value : '',
      productTitle: val(form, 'Product'), productUrl: val(form, 'Product URL'),
      selection: t.text, decoration: [this.methods.join(', ') || 'Not selected', this.positions.length ? 'Position: ' + this.positions.join(', ') : ''].filter(Boolean).join(' · '),
      priceBand: val(form, 'Price Band'), estimate: money(t.total), discountPercent: t.off,
      lines: lines, fields: fields
    };
    try {
      window.fetch(ENDPOINT, {method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin', keepalive: true, body: JSON.stringify(body)}).catch(function () {});
    } catch (e) {}
  };

  function val(form, name) { var el = form.querySelector('[name="contact[' + name + ']"]'); return el ? String(el.value || '') : ''; }
  function setText(root, sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }
  function setVal(root, key, v) { var el = root.querySelector('[data-q-h="' + key + '"]'); if (el) el.value = v; }
  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  function makeRef() {
    var d = new Date(), c = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '', i;
    function p(n) { return (n < 10 ? '0' : '') + n; }
    for (i = 0; i < 4; i++) r += c.charAt(Math.floor(Math.random() * c.length));
    return 'Q' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + r;
  }

  function init(root) { if (root && !root.__q4) { root.__q4 = new Builder(root); } }
  function scan(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-nsq4]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-nsq4]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, {once: true}); else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
